import { FEMA_FAQ, FEMA_PATH, FEMA_TRUST_QUESTIONS, resolveFemaProducts } from '../data/fema'
import { getStorefrontConfig, listStorefrontCategories, listStorefrontProducts } from './dropify'
import { listDashboardNewsPosts } from './news'
import { INDEXABLE_ROBOTS, absoluteUrl, brandTitle, buildBrandLandingSchema, buildBreadcrumbSchema, buildFaqSchema } from './seo'
import { getBrandProofImages } from './testimonials'

export async function loadFemaLanding() {
  const [config, categories, response, proofImages, newsPosts] = await Promise.all([
    getStorefrontConfig().catch(() => null),
    listStorefrontCategories().catch(() => []),
    listStorefrontProducts({ search: 'FEMA', per_page: 100 }).catch(() => null),
    getBrandProofImages().catch(() => []),
    listDashboardNewsPosts().catch(() => []),
  ])
  return { config, categories, products: resolveFemaProducts(response?.items ?? []), proofImages, newsPosts }
}

export function femaHead(data?: Awaited<ReturnType<typeof loadFemaLanding>>) {
  const title = brandTitle('Grosir CD FEMA: 361, 362, 363, 884 & 089/889')
  const description = 'Grosir celana dalam wanita FEMA untuk stok toko. Bandingkan 5 model, ukuran, dan motif. Cek stok serta quotation via WhatsApp Dropify Surabaya.'
  const products = data?.products ?? resolveFemaProducts([])
  const image = absoluteUrl(products[0].image)
  return {
    meta: [
      { title }, { name: 'description', content: description }, { name: 'robots', content: INDEXABLE_ROBOTS },
      { property: 'og:title', content: title }, { property: 'og:description', content: description },
      { property: 'og:url', content: absoluteUrl(FEMA_PATH) }, { property: 'og:image', content: image },
      { property: 'og:locale', content: 'id_ID' }, { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description }, { name: 'twitter:image', content: image },
    ],
    links: [{ rel: 'canonical', href: absoluteUrl(FEMA_PATH) }],
    scripts: [
      buildBrandLandingSchema({ brandName: 'FEMA', pageName: title, description, path: FEMA_PATH }),
      buildBreadcrumbSchema([{ name: 'Beranda', path: '/' }, { name: 'FEMA', path: '/merek/fema' }, { name: 'CD FEMA grosir', path: FEMA_PATH }]),
      buildFaqSchema([...FEMA_FAQ, ...FEMA_TRUST_QUESTIONS]),
      // Prices and inventory are quoted by the admin. Do not invent Offer data.
      { '@context': 'https://schema.org', '@type': 'ItemList', name: 'Lima model celana dalam FEMA', itemListElement: products.map((product, index) => ({
        '@type': 'ListItem', position: index + 1, item: { '@type': 'Thing', name: product.name, sku: product.sku,
          url: absoluteUrl(`/produk/${product.slug}`), image: absoluteUrl(product.image), description: product.detail,
          brand: { '@type': 'Brand', name: 'FEMA' }, size: product.sizes,
        },
      })) },
    ].map((schema) => ({ type: 'application/ld+json', children: JSON.stringify(schema) })),
  }
}
